export default __webpack_public_path__ + "static/Bild Seite 1 - Verkäuferin-8140846ab00cb66c5dd714004c1ec5e2.jpg";